import React from "react";

const AlertMessage = ({ message }) => {
  return (
    <div className="flex items-start md:items-center gap-2">
      <img src="/assets/icons/common/error-badge.svg" alt="error" className="size-4" />
      <span className="text-red-500 font-semibold text-[12px] md:text-[14px]">{message}</span>
    </div>
  );
};

export default AlertMessage;
